import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';

import {PatientEditComponent} from './patient-edit/patient-edit.component';
import {PatientFindComponent} from './patient-find/patient-find.component';
import {PatientService} from './patient.service';
import {environment} from '../../../environments/environment';
import {Globals} from '../../globals';
import {MessagingService} from '../../services/messaging.service';
import {PatientDialogDataModel} from './patient-dialog-data.model';

export interface DialogData {
  PatientID: string;
  name: string;
}

@Component({
  selector: 'app-patient',
  templateUrl: './patient.component.html',
  styleUrls: ['./patient.component.css']
})
export class PatientComponent implements OnInit {

  public thePatient: any;
  public currentPatient: string;
  errors: any;
  apps: any;

  messageSubscription: any;

  constructor(
    private _patientService: PatientService,
    public dialog: MatDialog,
    private globals: Globals,
    private messagingService: MessagingService
  ) {
  }

  ngOnInit() {

    this.messagingService.broadCastMessage('toggleLoading', {isLoading: true});

    // start the messaging subscription
    this.messageSubscription = this.messagingService.componentMessageCall.subscribe(response => {
      // if the event tokenDecoded contains a patientID, fetch the patient information
      // when patient information has been loaded, broadcast that it is ok to start the token redirect
      if (response.event == 'tokenDecoded' && typeof response.data.patientid != 'undefined') {
        this._patientService.getTDO12Patient(response.data.patientid).subscribe(data => {
          this.globals.currentPatientId = data;

          this._patientService.setCurrentPatient(this.globals.currentPatientId);

          this._patientService.getPatient(this.globals.currentPatientId).subscribe(data => {
            this.thePatient = data;
            this.globals.currentPatientFullName = this.thePatient.ThePatient.dataContact.FirstName + ' ' +
              this.thePatient.ThePatient.dataContact.MidName + ' ' +
              this.thePatient.ThePatient.dataContact.LastName;
            this.messagingService.broadCastMessage('startTokenRedirect', response);
            //this.messagingService.broadCastMessage("toggleLoading", { isLoading: false });
          }, err => {
            console.log(err);
            this.messagingService.broadCastMessage('toggleLoading', {isLoading: false});
          });


        });
      }

    });

    let patient = this._patientService.getCurrentPatient();
    if (!patient) {
      return;
    }
    if (this.globals.tdo12patientNO === '') {
      this._patientService.getPatient(this.globals.currentPatientId).subscribe(data => {
          this.thePatient = data;

          this.globals.currentPatientFullName = this.thePatient.ThePatient.dataContact.FirstName + ' ' +
            this.thePatient.ThePatient.dataContact.MidName + ' ' +
            this.thePatient.ThePatient.dataContact.LastName;
        },
        error => {
          this.errors = error;
        },
        () => {
          // No errors, route to new page
        }
      );

      //test appotment load
      //this._patientService.getAppotment().subscribe(data => {

      //  this.apps = data;

      //});

    } else {
      this._patientService.getTDO12Patient(this.globals.tdo12patientNO).subscribe(data => {
          this.globals.currentPatientId = data;

          this._patientService.getPatient(this.globals.currentPatientId).subscribe(data => {
              this.thePatient = data;

              this.globals.currentPatientFullName = this.thePatient.ThePatient.dataContact.FirstName + ' ' +
                this.thePatient.ThePatient.dataContact.MidName + ' ' +
                this.thePatient.ThePatient.dataContact.LastName;
              this.messagingService.broadCastMessage('toggleLoading', {isLoading: false});
            }, err => {
              this.messagingService.broadCastMessage('toggleLoading', {isLoading: false});
            }
          );


        }
      );
    }



  }


  openDialogPatientEdit(): void {
    const dm = new PatientDialogDataModel();
    dm.mode = PatientDialogDataModel.MODE_EDIT_PATIENT;
    dm.ThePatient = this.thePatient;
    const dialogRef = this.dialog.open(PatientEditComponent, {
      width: '968px',
      height: '562px',
      panelClass: 'tdo-note-dialog-main',
      data: dm
    });

    dialogRef.afterClosed().subscribe(result => {

      this.thePatient = result;
    });
  }

  openDialogPatientNew(): void {
    this.thePatient.NewPatient = true;
    const dm = new PatientDialogDataModel();
    dm.mode = PatientDialogDataModel.MODE_NEW_PATIENT;
    const dialogRef = this.dialog.open(PatientEditComponent, {
      panelClass: 'tdo-note-dialog-main',
      data: dm
    });

    dialogRef.afterClosed().subscribe(result => {

      this.thePatient = result;
    });
  }

  openDialogPatientFind(): void {
    const dialogRef = this.dialog.open(PatientFindComponent, {
      width: '650px',
      height: '600px',
      data: ''
    });

    dialogRef.afterClosed().subscribe(result => {
      // reload data
      environment.CurrentPatient = result;

      this._patientService.getPatient(environment.CurrentPatient).subscribe(data => {
        this.thePatient = data;
      });
    });
  }
}
